import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { connect } from 'react-redux';
import { GetRegion } from 'constants.js';
import * as actions from '../../../actions/response';
import { getConfig } from '../../../reducers/response';
import { converter } from '../../../helpers/converter';
import RequestManager from '../../../requests/RequestManager';
import G3Terms from '../../../requests/tasks/G3TermsTask';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalTermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  openTermsAndConditions = () => {
    const linkTerms = '/terminos_y_condiciones';
    const win = window.open(linkTerms, '_blank');
    win.focus();
  };

  acceptTerms = async () => {
    const { userDetectWS } = this.props;
    try {
      const { response } = await RequestManager.addRequest(
        new G3Terms(userDetectWS.url),
      );
      localStorage.removeItem('loginInfo.needsAcceptTerms');
      this.closeModal();
      location.reload();
    } catch (error) {
      this.closeModal();
      const modal = {
        modalType: 'ErrorSimple',
        props: {
          message: converter.convertApaUnicode(
            this.props.translations,
            'ip_telmex_error',
          ),
          onAccept: () => {
            this.props.closeModal('ErrorSimple');
          },
        },
      };
      this.props.showModal(modal);
    }
  };

  closeModal() {
    this.props.closeModal('TermsAndConditions');
  }

  render() {
    const closeButtonClass = 'close close-modal';
    const buttonContinueClass = 'btn btn-primary btn-block';
    const padding = { padding: '7px' };
    const margin = { margin: '5px' };
    return (
      <Modal show>
        <Modal.Header>
          <Button className={closeButtonClass} onClick={this.closeModal}>
            x
          </Button>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          <i
            className="fa text-center fa-3x fa-exclamation-triangle"
            aria-hidden="true"
          />
          <p className="padding-top-2">
            {converter.convertApaUnicode(
              this.props.translations,
              'terms_content_g3',
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="padding-top-05" style={margin}>
              <Button
                className={classButtonInactive}
                onClick={this.openTermsAndConditions}
                style={padding}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  'ip_telmex_read_tyc_button_g3',
                  'Leer Términos y Condiciones',
                )}
              </Button>
            </div>
            <div className="padding-top-05" style={margin}>
              <Button
                className={buttonContinueClass}
                style={padding}
                onClick={this.acceptTerms}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  'ip_telmex_continue_button_g3',
                  'Continuar',
                )}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalTermsAndConditions.propTypes = {
  closeModal: PropTypes.func.isRequired,
  translations: PropTypes.object,
  userDetectWS: PropTypes.object,
  showModal: PropTypes.func,
};

const mapStateToProps = state => ({
  modal: state.modal,
  config: state.config,
  user: state.user,
  translations: state.translations,
  apiConfig: getConfig(state),
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalTermsAndConditions);
